import { StyleSheet, View } from "@react-pdf/renderer";
import TitleAndDetailLine from "../../../components/TitleAndDetailLine/TitleAndDetailLine";
import { getPaymentDetails, getPaymentDetailsPaid } from "../../../../../utils/OrderPaymentDetails";
import { subdomainTypes } from "../../../../../context/availableSubdomains";

const styles = StyleSheet.create({
  orderSummaryContainer: {
    marginLeft: "auto",
    width: "40%",
  },
});

interface Props {
  order: any;
  appBranch: subdomainTypes | "";
}

const OrderSummary = (props: Props) => {
  const { order, appBranch } = props;
  const getDetails = () => {
    if (!order) return [];
    if (order.payment_status === "paid") return getPaymentDetailsPaid(order, appBranch);
    return getPaymentDetails(order, appBranch);
  };
  const paymentDetails = getDetails();

  return (
    <View style={styles.orderSummaryContainer}>
      {paymentDetails.map((paymentDetail, index) => (
        <TitleAndDetailLine key={index} line={[`${paymentDetail.title}:`, paymentDetail.value]} />
      ))}
    </View>
  );
};

export default OrderSummary;
